import React from "react";

import { Box, Chip, Container, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";
import clsx from "clsx";

import { useTranslation } from "react-i18next";

import useCart from "hooks/useCart";

import DollarSignIcon from "icons/DollarSignIcon";

const useStyles = makeStyles(theme => {
	return {
		root: {
			display: "flex",
			flexDirection: "column",
			padding: 0,
			paddingTop: theme.spacing(2),
			marginTop: theme.spacing(1)
		},
		titleRow: {
			marginBottom: theme.spacing(1),
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between"
		},
		titleBlock: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
			alignItems: "center",
			alignContent: "center"
		},
		icon: {
			marginRight: theme.spacing(1),
			height: theme.spacing(2),
			[theme.breakpoints.up(480)]: {
				display: "none"
			}
		},
		title: {
			fontSize: 12,
			textTransform: "uppercase",
			fontWeight: 500,
			color: "#fff",
			[theme.breakpoints.up(480)]: {
				color: theme.palette.text.primary,
				fontSize: 14,
				fontWeight: 500
			}
		},
		contentRow: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",
			alignItems: "center"
		},
		textField: {
			marginTop: theme.spacing(1),
			marginBottom: theme.spacing(1),
			width: 110,
			borderColor: "#fff",
			color: "#000",
			backgroundColor: "#f2f2f2",
			borderRadius: 8
		},
		toggle: {
			borderRadius: 8,
			height: 32,
			marginRight: theme.spacing(1),
			backgroundColor: "#f2f2f2",
			borderColor: "#f2f2f2"
		},
		toggleActive: {
			backgroundColor: theme.palette.primary.light,
			color: theme.palette.primary.contrastText,
			"&:hover": {
				backgroundColor: theme.palette.primary.light
			},
			"&:active": {
				backgroundColor: theme.palette.primary.light
			},
			"&:focus": {
				backgroundColor: theme.palette.primary.light
			}
		}
	};
});

interface TipProps {
	props?: any;
}

const Tip: React.FC<TipProps> = () => {
	const classes = useStyles();
	const { t } = useTranslation();
	const { setTipCents, getTipCents, orderType, tipPercentage } = useCart();

	const otherTipAmount = getTipCents();

	const onSelected = (tipPercentage: number) => {
		setTipCents(null, tipPercentage);
	};

	const onTipChanged = e => {
		const onlyNums = parseFloat(e.target.value.replace(/[^0-9.]/g, ""));
		setTipCents(onlyNums * 100, null);
	};

	const tipPercents = [10, 15, 20];

	return (
		<Container className={classes.root}>
			<Box className={classes.titleRow}>
				<Box className={classes.titleBlock}>
					<DollarSignIcon className={classes.icon} />
					<Typography className={classes.title}>
						{t("add")} {orderType && orderType?.orderType !== "pickup" ? orderType?.orderType : ""} {t("tip")}
					</Typography>
				</Box>
			</Box>
			<Box className={classes.contentRow}>
				<Box>
					{tipPercents.map(p => (
						<Chip
							component="a"
							key={`percent_${p}`}
							className={clsx(classes.toggle, tipPercentage === p ? classes.toggleActive : null)}
							label={`${p}%`}
							onClick={() => onSelected(p)}
						/>
					))}
				</Box>

				<CurrencyTextField
					className={classes.textField}
					placeholder={t("enterAmount")}
					variant="outlined"
					id="tipAmount"
					name="tipAmount"
					minimumValue={"0"}
					maximumValue={"100"}
					value={otherTipAmount / 100}
					onChange={onTipChanged}
					onKeyPress={e => {
						e.key === "Enter" && e.preventDefault();
					}}
				/>
			</Box>
		</Container>
	);
};

export default Tip;
